import { api } from '@/api/client';

export interface AuditEvent {
  id: number;
  tenant_id: string;
  user_id: string | null;
  user_email: string | null;
  action: string;
  resource_type: string | null;
  resource_id: string | null;
  extra: Record<string, unknown>;
  ip: string | null;
  user_agent: string | null;
  created_at: string;
}

export interface AuditListResponse {
  events: AuditEvent[];
  has_more: boolean;
  next_cursor: string | null;
}

export interface AuditQueryParams {
  limit?: number;
  before?: string;
  action_prefix?: string;
  user_id?: string;
}

export interface AuditVerifyResult {
  ok: boolean;
  events_checked: number;
  first_broken_event_id: number | null;
  reason: string | null;
}

export const auditApi = {
  /** Recalculează lanțul de hash al tenantului (owner/admin). */
  verify: (tenantId: string) =>
    api.get<AuditVerifyResult>(`/tenants/${tenantId}/audit/verify`),

  list: (tenantId: string, params: AuditQueryParams = {}) => {
    const qs = new URLSearchParams();
    if (params.limit) qs.set('limit', String(params.limit));
    if (params.before) qs.set('before', params.before);
    if (params.action_prefix) qs.set('action_prefix', params.action_prefix);
    if (params.user_id) qs.set('user_id', params.user_id);
    const query = qs.toString();
    return api.get<AuditListResponse>(
      `/tenants/${tenantId}/audit${query ? `?${query}` : ''}`,
    );
  },
};
